import { shipmentLegIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";
import {
  OverboxLegDtoSchema,
  OverboxLegParcelDtoSchema,
  OverboxTrackingEventDtoSchema,
} from "./overbox-leg-dto";

export const getOverboxLeg = {
  name: "getOverboxLeg" as const,
  input: z.object({ shipmentLegId: shipmentLegIdFormat.schema }),
  output: z.object({
    leg: OverboxLegDtoSchema,
    parcels: z.array(OverboxLegParcelDtoSchema),
    /** The leg's first-mile tracking timeline. */
    trackingEvents: z.array(OverboxTrackingEventDtoSchema),
  }),
};
